const contactPaymentDone = 'CONTACT_PAYMENT_DONE';
const contactPayment = 'BUSINESS_PAYMENT';

export default {
  contactPayment,
  contactPaymentDone,
};
